export const API_URL = "";
export const ADDRESS_BSCS_ADDRESS =
  "0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d";
export const SWAP_BSCS_URL =
  "https://bscs.finance/#/swap?outputCurrency=0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d";
export const NFT_URL = "https://nft.bscs.finance";
export const DEFAI = "https://defai.bscs.finance"
export const XCONNECT = "https://xconnect.bscs.finance"
export const AIR_DROP = "https://xconnect.bscs.finance/airdrop";
export const LAUNCHPAD = "https://launchpad.bscs.finance";
export const DOCS_URL = "https://docs.bscstation.finance/";
export const GITHUB_URL = "https://github.com/BSCSGlobal";
export const CERTIK_AUDIT_URL = "https://skynet.certik.com/projects/bscs";
export const Quillhash_AUDIT_URL =
  "https://github.com/Quillhash/QuillAudit_Reports/blob/master/BSCS%20Smart%20Contract%20Audit%20Report%20-%20QuillAudits.pdf";
export const PECKSHIELD_AUDIT_URL =
  "https://github.com/peckshield/publications/blob/master/audit_reports/PeckShield-Audit-Report-BSCStationStartPools-v1.0.pdf";
export const SolidProof_URL =
  "https://github.com/solidproof/projects/tree/main/BSCStation";

export const TWITTER_URL = "https://twitter.com/BSCS_Global";
export const TELEGRAM_URL = "https://t.me/BSCS_Channel";
export const FACE_URL = "https://www.facebook.com/BSCS.Channel";
export const YOUTUBE_URL = "https://www.youtube.com/@BSCSOfficial";
export const REDIT_URL = "https://www.reddit.com/r/BSCStation/";
export const SUBSTACK = "https://bscstation.substack.com/";
export const BUILDERS = "https://t.me/BSCS_Channel/4059";
export const SUPPORT = "https://support.bscs.finance/portal/en/home";
export const APPLY = "https://launchpad.bscs.finance/apply-to-launch";

export const BRAND = "https://bscs.finance/brand";
export const VERIFY = "https://bscs.finance/verify";
export const TOKEN = "https://bscs.finance/static/media/Tokenomics2.d346f29955b6ae411460.pdf";
export const TERM = 'https://bscs.finance/term'
export const PRIVACY = 'https://bscs.finance/privacy'
export const COOKIE = 'https://bscs.finance/cookie'
export const LOGO_ICON =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/ae1e8eff3079d9e6fda98d093af950a6cc73745e669c4a85f3.png";
export const PANCAKE = "https://pancakeswap.finance/swap?outputCurrency=0xbcb24AFb019BE7E93EA9C43B7E22Bb55D5B7f45D";
export const MEXC = "https://www.mexc.com/exchange/BSCS_USDT";
export const GATEIO = "https://www.gate.io/trade/BSCS_USDT";